import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import BaiduMap from 'vue-baidu-map';
import { vModelString } from '@/mixins/component-vmodel.js';
Vue.use(BaiduMap, {
  ak: 'bPxv5LdsECV1EOQUpR0nCvCDZbL7U57N'
});
export default {
  name: 'd2-map',
  mixins: [vModelString],
  props: {
    // 值
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    model: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    }
  },
  data: function data() {
    return {
      center: {
        lng: 109.45744048529967,
        lat: 36.49771311230842
      },
      zoom: 21,
      currentValue: 0,
      hackReset: true
    };
  },
  watch: {
    currentValue: {
      handler: function handler() {
        this.hackReset = false;
        var that = this;
        this.$nextTick(function () {
          that.hackReset = true;
        });
      }
    }
  },
  methods: {
    handler: function handler(_ref) {
      var BMap = _ref.BMap,
          map = _ref.map;
      // console.log(this.currentValue.longitude)
      // console.log(this.currentValue.latitude)
      var point = new BMap.Point(109.49926175379778, 36.60449676862417);

      if (this.currentValue.longitude && this.currentValue.latitude) {
        point = new BMap.Point(this.currentValue.longitude, this.currentValue.latitude);
      } else {// var geolocation = new BMap.Geolocation()
        // geolocation.getCurrentPosition((r) => {
        //     console.log(r)
        //     console.log(r.address.city)
        //     point = new BMap.Point(r.longitude, r.latitude)
        // }, {enableHighAccuracy: true})
        // 请检查您的浏览器是否禁用了获取位置
        //enableHighAccuracy：是否要求浏览器获取最佳效果，默认为false
      }

      map.centerAndZoom(point, 21);
      var marker = new BMap.Marker(point); // 创建标注

      map.addOverlay(marker); // 将标注添加到地图中

      var circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#f03'
      });
      map.addOverlay(circle);
    },
    getClickInfo: function getClickInfo(e) {
      // console.log(e.point.lng)
      // console.log(e.point.lat)
      this.center.lng = e.point.lng;
      this.center.lat = e.point.lat; // this.currentValue = e.point.lng+''

      this.currentValue.longitude = e.point.lng + '';
      this.currentValue.latitude = e.point.lat + '';
      var pt = e.point;
      var that = this;
      var geoc = new BMap.Geocoder(); //创建地址解析器的实例

      geoc.getLocation(pt, function (rs) {
        // console.log(rs)
        // console.log(rs.surroundingPois); //附近的POI点(array)
        //console.log(rs.business); //商圈字段，代表此点所属的商圈(string)
        var addComp = rs.addressComponents; // console.log(addComp.province+addComp.city+addComp.district+addComp.street+addComp.streetNumber)

        that.currentValue.province = addComp.province;
        that.currentValue.city = addComp.city;
        that.currentValue.district = addComp.district;
        that.currentValue.street = addComp.street;
        that.currentValue.address = addComp.streetNumber;
      }); // this.vModelMixinEmit()
    }
  }
};